<div class="page-content bg-white">
  <!-- inner page banner -->
  <!-- <div class="dez-bnr-inr overlay-black-middle" style="background-image:url('/assets/images/bg4.jpg');">
    <div class="container">
      <div class="dez-bnr-inr-entry">
        <h1 class="text-white">{{content[0].menu}}</h1>
      </div>
    </div>
  </div> -->
  <!-- inner page banner END -->
  <!-- Breadcrumb row -->
  <div class="breadcrumb-row">
    <div class="container">
      <ul class="list-inline">
        <li><a href="#">Inicio</a></li>
        <li>{{content[0].Titulo}}</li>
      </ul>
    </div>
  </div>
  <!-- Breadcrumb row END -->
  <!-- contact area -->
  <div class="content-area">
    <!-- Career -->
    <div class="container">
      <div class="row">
        <!-- Left part start -->
        <div class="col-md-9 m-b30">
          <h1 class="m-b20 m-t0">{{content[0].Titulo}}</h1>
          <div class="dez-separator bg-primary"></div>
          <p style="text-align: justify;" [innerHTML]="content[0].Texto"></p>
        </div>
        <!-- Left part start END -->
        <!-- Right part start -->
        <div class="col-md-3">
          <div class="widget bg-white recent-posts-entry">
            <h4 class="widget-title">Documentos importantes</h4>
            <div class="widget-post-bx">
              <ng-container *ngFor="let item of documentos">
                <div class="widget-post clearfix">
                  <div class="dez-post-media"> <img src="{{domain}}/{{item.imagen}}" alt="" width="200" height="143">
                  </div>
                  <div class="dez-post-info">
                    <div class="dez-post-header">
                      <h6 class="post-title">
                        <div *ngIf="item.url>0;then uno else dos"></div>
                        <ng-template #uno>
                          <a href="" [routerLink]="'/content/'+item.url">{{item.titulo}}</a>
                        </ng-template>
                        <ng-template #dos>
                          <a target="_blank" href="{{domain}}/{{item.url}}">{{item.titulo}}</a>
                        </ng-template>
                      </h6>
                    </div>
                    <div class="dez-post-meta">
                      <ul>
                        <li class="post-author">By Admin</li>
                        <li class="post-comment"><i class="fa fa-comments"></i> 28</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <!-- Right part start END -->
      </div>
    </div>
    <!-- Career END -->
  </div>
  <!-- contact area END -->
</div>


// WEBPACK FOOTER //
// ./src/app/pages/content/content.component.html